module.exports = __webpack_public_path__ + "792158d3c84c5e19e94885e7f47a2727.svg";